import script from "./pazienteAggiuntiveEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./pazienteAggiuntiveEdit.vue?vue&type=script&setup=true&lang=ts"

import "./pazienteAggiuntiveEdit.vue?vue&type=style&index=0&id=4be5f8eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4be5f8eb"]])

export default __exports__